<template>
  <div>
    <form @submit.prevent="save">
      <div class="email-input" v-if="!authorized">
        <input type="email"
               class="input"
               required
               placeholder="Enter your email address..."
               :value="email"
               @input="setEmail"
               v-if="isNewDesign">
        <input type="text"
               class="input"
               required
               placeholder="Enter secret..."
               :value="secret"
               @input="setSecret"
               v-else>
        <button type="submit" class="button-submit">Submit</button>
      </div>
      <button type="submit" class="button" v-if="authorized">
        Save changes
      </button>
    </form>
    <div v-if="saveSuccess">
      {{ saveSuccess }}
    </div>
    <div v-if="saveError">
      {{ saveError }}
    </div>
  </div>
</template>

<script>
  export default {
    computed: {
      email () {
        return this.$store.state.email
      },
      authorized () {
        return this.$route.params.id && this.$store.state.authorized
      },
      isNewDesign () {
        return this.$route.params.slug
      },
      saveError () {
        return this.$store.state.saveError
      },
      saveSuccess () {
        return this.$store.state.saveSuccess
      },
      secret () {
        return this.$store.state.secret
      }
    },
    created() {
      const localSecret = this.isNewDesign
        ? this.generateNewSecret()
        : ''

      this.$store.commit('setSecret', localSecret)
    },
    methods: {
      save () {
        this.$store.dispatch('save')
      },
      setEmail (event) {
        this.$store.commit('setEmail', event.target.value)
      },
      setSecret (event) {
        this.$store.commit('setSecret', event.target.value)
      },
      generateNewSecret() {
        let text = ''
        const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

        for (var i = 0; i < 5; i++)
          text += possible.charAt(Math.floor(Math.random() * possible.length))

        return text
      }
    }
  }
</script>

<style lang="postcss" scoped>
  .email-input {
    position: relative;
    width: 300px;
  }

  .input {
    display: block;
    width: 100%;
    height: 45px;
    border: solid 2px #aeaeae;
    padding: 0 60px 0 1em;
    line-height: 41px;
  }

  .button-submit {
    position: absolute;
    top: 0;
    right: 0;
    width: 90px;
    height: 45px;
    border: none;
    // background: url(../assets/chevron-right.png) no-repeat center center;
    background: #929496;
    color: #fff;
    font-size: 12px;
    text-transform: uppercase;
  }

  .button {
    display: block;
    width: 270px;
    border: solid 2px #aeaeae;
    height: 45px;
  }
</style>



// WEBPACK FOOTER //
// SaveForm.vue?28e2bb80